import {DTControlMode} from 'common/src/modules/decisionTree/treeTypes';
import {CampaignTreeState} from './campaignTree.types';
import {DTZoom} from 'common/src/modules/decisionTree/decisionTree.types';

const DEFAULT_DT_ZOOM: DTZoom = {isOn: false, withAnimation: false, moveCampaignNode: false};

const campaignTreeInitialState: CampaignTreeState = {
  campaignPlacements: [],
  versionNumber: null,
  versionId: null,
  controlMode: DTControlMode.Default,
  campaignVersions: [],
  disableCampaignChangesReasons: [],
  isCampaignChangedByCollaborator: false,
  tearsheetName: '',
  isScheduled: false,
  isCampaignOutputMenuOpen: false,
  isCampaignLoading: false,
  draftNode: null,
  campaign: null,
  conceptCampaign: null,
};

export {campaignTreeInitialState, DEFAULT_DT_ZOOM};
